<!-- 23714677 工单ID -->
<template>
  <div class="media-list-container">
    <div
      v-for="(item, index) in props.mediaList"
      :key="index"
      class="media-item"
      :style="{ display: index > 3 ? 'none' : 'block' }"
      @click="openPreview(index)"
    >
      <img v-if="index < 3 && item.type === 'video'" :src="videoPlay" class="playIcon" />
      <a-image
        v-if="item.type === 'image'"
        :src="item.url"
        :alt="`图片 ${index + 1}`"
        height="100%"
        width="100%"
        :preview="false"
      />
      <video
        v-else
        :poster="item.poster"
        :src="item.url"
        :alt="`视频 ${index + 1}`"
        class="video"
      />
      <div v-if="props?.mediaList?.length > 4 && index === 3" class="more-images">
        <span class="more-text">+{{ props?.mediaList?.length - 3 }}</span>
      </div>
    </div>
  </div>

  <!-- 媒体预览弹窗 -->
  <a-modal
    v-model:visible="isModalVisible"
    title="预览"
    :width="800"
    :footer="null"
    @cancel="closePreview"
  >
    <div class="media-preview-modal">
      <!-- 视频预览 -->
      <div v-if="getCurrentMediaType === 'video'" class="video-container">
        <video
          :poster="getCurrentMedia?.poster"
          :src="getCurrentMedia?.url"
          controls
          class="preview-video"
        />
      </div>
      <!-- 图片预览 -->
      <div v-else class="image-container">
        <a-image
          :src="getCurrentMedia?.url"
          :alt="`图片 ${currentMediaIndex + 1}`"
          height="500px"
          width="100%"
          :preview="true"
        />
      </div>

      <!-- 媒体控制 -->
      <div class="media-controls">
        <button class="control-btn prev-btn" @click="prevMedia" :disabled="currentMediaIndex === 0">
          ← 上一个
        </button>
        <span class="media-counter">
          {{ currentMediaIndex + 1 }} / {{ props.mediaList.length }}
          <span class="media-type">
            （{{ getCurrentMediaType === 'video' ? '视频' : '图片' }}）
          </span>
        </span>
        <button
          class="control-btn next-btn"
          @click="nextMedia"
          :disabled="currentMediaIndex === props.mediaList.length - 1"
        >
          下一个 →
        </button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue'
import videoPlay from '@/assets/img/chat/videoPlay.png'

const props = defineProps({
  mediaList: {
    type: Array,
    default: () => []
  }
})

// 弹窗控制
const isModalVisible = ref(false)
const currentMediaIndex = ref(0)

// 获取当前媒体信息
const getCurrentMedia = computed(() => {
  return props.mediaList[currentMediaIndex.value]
})

// 获取当前媒体类型
const getCurrentMediaType = computed(() => {
  const media = getCurrentMedia.value
  return media?.type === 'image' ? 'image' : 'video'
})

// 打开预览
const openPreview = index => {
  currentMediaIndex.value = index
  isModalVisible.value = true
}

// 关闭预览
const closePreview = () => {
  isModalVisible.value = false
}

// 上一个媒体
const prevMedia = () => {
  if (currentMediaIndex.value > 0) {
    currentMediaIndex.value--
  }
}

// 下一个媒体
const nextMedia = () => {
  if (currentMediaIndex.value < props.mediaList.length - 1) {
    currentMediaIndex.value++
  }
}
</script>

<style scoped lang="scss">
.media-list-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.media-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f5f5f5;
  aspect-ratio: 1;
  position: relative;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .playIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    pointer-events: none;
    z-index: 1;
  }
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.more-images {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000066;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.more-text {
  color: #ffffff;
  font-size: 20px;
  font-weight: 400;
}

// 媒体预览弹窗样式
.media-preview-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .video-container,
  .image-container {
    width: 100%;
    background-color: #000;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-container {
    height: 500px;

    .preview-video {
      height: 500px;
      width: 100%;
      height: auto;
      max-height: 500px;
    }
  }

  .image-container {
    ::v-deep(.ant-image) {
      height: 500px;
    }
    ::v-deep(.ant-image-img) {
      object-fit: contain;
    }
  }

  .media-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    .control-btn {
      padding: 8px 16px;
      background-color: #1890ff;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      transition: background-color 0.2s ease;

      &:hover:not(:disabled) {
        background-color: #40a9ff;
      }

      &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
      }
    }

    .media-counter {
      font-size: 14px;
      color: #666;
      min-width: 120px;
      text-align: center;

      .media-type {
        font-size: 12px;
        color: #999;
        margin-left: 4px;
      }
    }
  }
}
</style>
